import { hasNativeBridge } from '@/api/nativeBridge';
import { PropsWithChildren, ReactNode } from 'react';

type PropsType = PropsWithChildren<{
  fallback?: ReactNode;
}>;

const RenderIfBridge = ({ children, fallback }: PropsType) => {
  const isLocalHost = window.location.hostname === 'localhost';

  if (!hasNativeBridge() && !isLocalHost) return fallback;

  return children;
};
export default RenderIfBridge;
